
import { Resource } from "src/app/core/jsonapi/resource";
import { prop, propObject, required } from "@rxweb/reactive-form-validators";

export class CostCenter extends Resource {
    public override type = 'costCenters';
    
    @prop()
    @required()
    public name!: string;      
    
    @prop()
    public code!: string;     

    @prop()    
    public default: boolean = true;       
    
    
}